import type { GradePointMapping } from '@gpa-scales/shared-types';

export const LETTER_GRADE_POINTS_PLUS_MINUS: GradePointMapping[] = [
  { grade: 'A+', points: 4.0, isPassing: true },
  { grade: 'A', points: 4.0, isPassing: true },
  { grade: 'A-', points: 3.7, isPassing: true },
  { grade: 'B+', points: 3.3, isPassing: true },
  { grade: 'B', points: 3.0, isPassing: true },
  { grade: 'B-', points: 2.7, isPassing: true },
  { grade: 'C+', points: 2.3, isPassing: true },
  { grade: 'C', points: 2.0, isPassing: true },
  { grade: 'C-', points: 1.7, isPassing: true },
  { grade: 'D+', points: 1.3, isPassing: true },
  { grade: 'D', points: 1.0, isPassing: true },
  { grade: 'D-', points: 0.7, isPassing: true },
  { grade: 'F', points: 0.0, isPassing: false },
];

export const LETTER_GRADE_POINTS_NO_PLUS_MINUS: GradePointMapping[] = [
  { grade: 'A', points: 4.0, isPassing: true },
  { grade: 'B', points: 3.0, isPassing: true },
  { grade: 'C', points: 2.0, isPassing: true },
  { grade: 'D', points: 1.0, isPassing: true },
  { grade: 'F', points: 0.0, isPassing: false },
];

export const PERCENTAGE_TO_LETTER_THRESHOLDS: { min: number; letter: string }[] = [
  { min: 93, letter: 'A' },
  { min: 90, letter: 'A-' },
  { min: 87, letter: 'B+' },
  { min: 83, letter: 'B' },
  { min: 80, letter: 'B-' },
  { min: 77, letter: 'C+' },
  { min: 73, letter: 'C' },
  { min: 70, letter: 'C-' },
  { min: 67, letter: 'D+' },
  { min: 63, letter: 'D' },
  { min: 60, letter: 'D-' },
  { min: 0, letter: 'F' },
];

export const IB_SCALE_MAPPING: GradePointMapping[] = [
  { grade: '7', points: 4.0, isPassing: true },
  { grade: '6', points: 3.7, isPassing: true },
  { grade: '5', points: 3.3, isPassing: true },
  { grade: '4', points: 3.0, isPassing: true },
  { grade: '3', points: 2.0, isPassing: true },
  { grade: '2', points: 1.0, isPassing: true },
  { grade: '1', points: 0.0, isPassing: false },
];

export const ECTS_SCALE_MAPPING: GradePointMapping[] = [
  { grade: 'A', points: 4.0, isPassing: true },
  { grade: 'B', points: 3.3, isPassing: true },
  { grade: 'C', points: 2.7, isPassing: true },
  { grade: 'D', points: 2.0, isPassing: true },
  { grade: 'E', points: 1.0, isPassing: true },
  { grade: 'F', points: 0.0, isPassing: false },
];
